import { useNavigate } from "react-router-dom";
import Nav from "@/components/Nav";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div><Nav />
      <div className="max-w-md mx-auto px-5 py-24 text-center">
        <h1 className="font-serif text-3xl mb-2">Checkout cancelled</h1>
        <p className="text-slate-400 mb-6">No worries — your free archetype is still there.</p>
        <button onClick={()=>nav("/dashboard")} className="px-6 py-3 rounded-xl bg-[#E0A96D] text-[#070C18] font-semibold hover:bg-[#F0C28B]" data-testid="back-dashboard">
          Back to dashboard
        </button>
      </div>
    </div>
  );
}
